import { Form } from "react-bootstrap";
import PropTypes from "prop-types";

const ACFOptInCheckbox = ({
	headerClassname,
	label,
	message,
	name,
	onChange,
	required,
	value
}) => (
	<>
		{label ? <div className={headerClassname}>{label}</div> : null}
		<Form.Check
			defaultChecked={value}
			id={name}
			label={message}
			name={name}
			onChange={onChange}
			required={required}
		/>
	</>
);

ACFOptInCheckbox.propTypes = {
	headerClassname: PropTypes.string,
	label: PropTypes.string,
	message: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	required: PropTypes.bool,
	value: PropTypes.bool
};

ACFOptInCheckbox.defaultProps = {
	headerClassname: "fw-bold form-label mb-2",
	label: null,
	required: false,
	value: null
};

export default ACFOptInCheckbox;
